
import { defineComponent } from 'vue'
import { mapActions } from 'vuex'
import { OrgGroupsActions } from '~/store/control-panel/groups'

export default defineComponent({
  name: 'ControlPanelEditGroupModal',

  data() {
    return {
      creatingGroup: false,
      showCreateGroupModal: false,
      newGroupName: ''
    }
  },

  methods: {
    ...mapActions('control-panel/groups', {
      createOrgGroup: OrgGroupsActions.CREATE_GROUP
    }),

    showModal(): void {
      this.showCreateGroupModal = true
    },

    async createGroup(close: () => void): Promise<void> {
      this.creatingGroup = true
      const response = await this.createOrgGroup({ groupName: this.newGroupName })
      if (response) {
        this.newGroupName = ''
        this.$emit('refetch')
        this.$toast.success('Group created successfully.')
        if (close) close()
      } else {
        this.$toast.danger('An error occured while deleting group, please try again.')
      }
      this.creatingGroup = false
    }
  }
})
